<template>
  <section>
    <div class="button-wrap">
      <div class="pure-button">button A</div>
      <div class="pure-button">button B</div>
      <div class="pure-button">button C</div>
      <div class="pure-button">button D</div>
    </div>
    <div class="chart-toggle" v-on:click="chartToggle()">Toggle labels</div>
    <div class="chart-wrap">
      <canvas id="myChart" width="904" height="478"></canvas>
    </div>
  </section>
</template>

<script>
  /* global $ */
  import Chart from 'chart.js'
  import Datalabels from 'chartjs-plugin-datalabels'
  import db from './firebaseInit'

  export default {
    name: 'chart',
    data () {
      return {
        dataset: this.chartData,
        labels: [],
        radius: [],
        topBuzz: 0,
        scatterChart: null,
        lastAlign: 'right',
        lastX: 0,
        lastY: 0,
        tolerance: 1,
        defaultLabels: true,
        chartLabelsHidden: false
      }
    },
    props: {
      chartData: {
        type: Array,
        required: false,
        mustProcess: false
      },
      resultsCount: {
        type: Number,
        required: false,
        mustProcess: false
      },
      single: false
    },
    created () {
      // this.fetchData()
    },
    watch: {
      chartData() {
        let vm = this
        console.log('updating chart data')
        vm.removeChartData()
        for (var i = 0; i < this.chartData.length; i++) {
          var movieData = this.chartData[i]
          if (movieData.Quality && movieData.Quality >= 50 && movieData.Buzz) {
            var thisDataset = {
              x: movieData.Quality,
              y: movieData.Buzz,
              label: movieData.Title,
              ///radius: movieData.Quality
            }
            // vm.radius.push(movieData.Buzz * 0.5)
            if (movieData.Buzz > vm.topBuzz) {
              console.log('Buzz: ' + movieData.Buzz + ', title: ' + movieData.Title)
              // vm.topBuzz = Math.ceil(movieData.Buzz)
              vm.topBuzz = movieData.Buzz
            }
            vm.labels.push(movieData.Title)
            vm.dataset.push(thisDataset)
            vm.updateChartData()           
          }
        }
        if (vm.dataset.length > 20) {
          vm.defaultLabels = false
          vm.chartLabelsHidden = true
        } else {
          vm.defaultLabels = true
          vm.chartLabelsHidden = false
        }
        vm.createChart(vm.defaultLabels)
      }
    },
    methods: {
      fetchData () {
        // let vm = this
        // var moviesRef = db.collection('movies').limit(50)
        // moviesRef.get().then((querySnapshot) => {
        //   console.log('created query: ' + querySnapshot.docs.length)
        //   querySnapshot.forEach((doc) => {
        //     var movieData = doc.data()
        //     if (movieData.Quality && movieData.Quality >= 50 && movieData.Buzz) {
        //       var thisDataset = {
        //         x: movieData.Quality,
        //         y: movieData.Buzz,
        //         label: movieData.Title,
        //         radius: movieData.Quality * 1.5
        //       }
        //       vm.radius.push(movieData.Buzz)
        //       vm.labels.push(movieData.Title)
        //       vm.dataset.push(thisDataset)
        //       // vm.updateChartData()
        //     }
        //   })
        //   vm.createChart()
        // })
      },
      dataSort: function (array) {
        let vm = this
        array.sort(function (a, b) {
          var countA = a.y ? parseFloat(a.y) : 0
          var countB = b.y ? parseFloat(b.y) : 0
          return countA - countB
          // return countB - countA
        })
      },
      createChart : function (labels) {
        let vm = this
        var count = 0;
        if (vm.scatterChart) {
          vm.scatterChart.destroy()
        }
        vm.dataSort(vm.dataset)
        console.log('top Buzz: ' + vm.topBuzz)
        var ctx = document.getElementById("myChart");
        var pointBackgroundColors = [];
        var pointBorderColors = [];
        // ctx.style.backgroundColor = 'rgb(255,255,255)';
        Chart.defaults.global.defaultFontFamily = "'Open Sans', sans-serif";
        Chart.defaults.global.pointHitDetectionRadius = 2;
        // Chart.scaleService.updateScaleDefaults('linear', {
        //     ticks: {
        //         min: 50,
        //         max: 100
        //     }
        // });
        vm.scatterChart = new Chart(ctx, {
          type: 'scatter',
          data: {
              labels: vm.labels,
              datasets: [{
                  label: 'Scatter Dataset',
                  data: vm.dataset,
                  radius: vm.radius,
                  pointRadius: vm.radius,
                  pointHoverRadius: vm.radius,
                  pointBackgroundColor: pointBackgroundColors,
                  pointBorderColor: pointBorderColors
              }]
          },
          options: {
            legend: {
              display: false,
              labels: {
                fontColor: 'rgb(255, 99, 132)'
              }
            },
            onClick: function(c,i) {
              var e = i[0];
              if (e) {
                var data = this.data.datasets[0].data[e._index];
                var title = data.label;
                vm.loadMoviePanel(title)
              }
            },
            defaultFontFamily: "'PT Sans', sans-serif",
            plugins: {
              datalabels: {
                color: '#222',
                // backgroundColor: vm.dataset.length > 20 ? '#fff' : 'transparent',
                display: function(context) {
                  if (labels) {
                    var index = context.dataIndex;
                    if (context.dataset.data[index].y > 2 || context.dataset.data[index].y > (vm.topBuzz / 10)) {
                      return true;
                    } else {
                      return false;
                    }
                  } else {
                    return context.active;
                  }
                },
                align: function(context) {
                  var align = 'right'
                  var index = context.dataIndex;
                  var thisX = context.dataset.data[index].x
                  var thisY = context.dataset.data[index].y
                  
                  if (count <= vm.dataset.length) {
                    if (vm.lastX != 0 && vm.difference(thisX, vm.lastX) < 4 ) {
                      align = 'left'
                    }
                    if (vm.lastX != 0 && vm.difference(thisX, vm.lastX) > 4 && vm.difference(thisY, vm.lastY) < 2) {
                      align = 'bottom'
                    }
                      // if (vm.difference(thisX, vm.lastX) < 6 || ( vm.difference(thisX, vm.lastX) < 4 && vm.difference(thisY, vm.lastY) < 2 ) ) {
                      //   align = 'right'
                      // }
                    if (thisX != 0) {
                      vm.lastX = thisX
                    }
                    if (thisY != 0) {
                      vm.lastY = thisY
                    }
                  }
                  
                  count++

                  return align

                  // if (vm.lastAlign === 'left') {
                  //   vm.lastAlign = 'right'
                  //   return 'right'           
                  // } else {
                  //   vm.lastAlign = 'left'
                  //   return 'left'
                  // }
                },
                anchor: function(context) {
                  // return context.dataset.data[context.dataIndex].x > 70 ? 'end' : 'start';
                },
                offset: function(context) {
                  return 6
                },
                font: {
                  weight: 'bold'
                }
              }
            },
            tooltips: {
              enabled: false,
              callbacks: {
                label: function(tooltipItem, data) {
                  var label = data.labels[tooltipItem.index];
                  if (data.datasets[0].data[tooltipItem.index].y <= 2) {
                    return label;
                  } else {
                    return false;
                  }
                  // return label + ': (' + tooltipItem.xLabel + ', ' + tooltipItem.yLabel + ')';
                }
              }
            },
            scales: {
              xAxes: [{
                type: 'linear',
                position: 'bottom',
                ticks: {
                  autoSkip: true,
                  maxTicksLimit: 5,
                  min: 50,
                  max: 100,
                  stepSize: 12.5
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Quality'
                },
                gridLines: {
                  color: ['rgba(0,0,0,0.3)', 'rgba(0,0,0,0.05)', 'rgba(0,0,0,0.3)', 'rgba(0,0,0,0.05)', 'rgba(0,0,0,0.1)']
                }
              }],
              yAxes: [{
                ticks: {
                    autoSkip: true,
                    maxTicksLimit: 3,
                    min: 0,
                    max: vm.topBuzz,
                    stepSize: vm.topBuzz / 2
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Buzz'
                },
                gridLines: {
                  color: ['rgba(0,0,0,0.1)', 'rgba(0,0,0,0.2)', 'rgba(0,0,0,0.1)']
                }
              }]
            }
          }
        });

        let midX = 75
        let midY = vm.topBuzz / 2
        
        for (var i = 0; i < this.scatterChart.data.datasets[0].data.length; i++) {
          var thisPoint = this.scatterChart.data.datasets[0].data[i]
          if (thisPoint.x < midX && thisPoint.y < midY) { // bottom left
            this.scatterChart.data.datasets[0].pointBackgroundColor[i] = '#747474'
            this.scatterChart.data.datasets[0].pointBorderColor[i] = '#747474'
          } else if (thisPoint.x >= midX && thisPoint.y < midY) { // bottom right
            this.scatterChart.data.datasets[0].pointBackgroundColor[i] = '#EA9413'
            this.scatterChart.data.datasets[0].pointBorderColor[i] = '#EA9413'
          } else if (thisPoint.x < midX && thisPoint.y >= midY) { // top left
            this.scatterChart.data.datasets[0].pointBackgroundColor[i] = '#136386'
            this.scatterChart.data.datasets[0].pointBorderColor[i] = '#136386'
          } else if (thisPoint.x >= midX && thisPoint.y >= midY) { // top right
            this.scatterChart.data.datasets[0].pointBackgroundColor[i] = '#9F1E10'
            this.scatterChart.data.datasets[0].pointBorderColor[i] = '#9F1E10'
          }
        }
        this.scatterChart.update();
      },
      difference: function (a, b) {
        return Math.abs(a - b);
      },
      updateChartData: function () {
        if (this.scatterChart) {
          // this.scatterChart.data.labels.push(label);
          // this.scatterChart.data.datasets.forEach((dataset) => {
          //     dataset.data.push(data);
          // });
          // do chart update
          this.scatterChart.update()
        }
      },
      removeChartData: function () {
        if (this.scatterChart) {
          // this.scatterChart.data.labels.pop();
          // this.scatterChart.data.datasets.forEach((dataset) => {
          //     dataset.data.pop();
          // });
          this.topBuzz = 0
          this.dataset = []
          this.radius = []
          this.labels = []
          this.scatterChart.update()
        }
      },
      chartToggle: function () {
        if (this.chartLabelsHidden) {
          this.chartLabelsHidden = false
          this.createChart(true)
        } else {
          this.chartLabelsHidden = true          
          this.createChart(false)
        }
      },
      loadMoviePanel: function (title) {
        this.$eventHub.$emit('load-movie-panel', title)
      }
    },
    mounted () {
      
    }
  };
</script>

<style scoped>
  .heading {
    background: #eaeaea;
    text-align: left;
    padding: 15px;
    margin: 0 0 20px;
  }
  .chart-wrap {
    width: 100%;
    max-width: 904px;
    margin: 0 auto;
    font-family: 'PT Sans', sans-serif;
  }
  .button-wrap {
    text-align: center;
    margin-bottom: 20px;
    margin-left: 41px;
  }
  .button-wrap > .pure-button {
    width: 23%;
    height: 47px;
    line-height: 47px;
    padding: 0 20px;
    margin: 0 5px;
    font-size: 1.2em;
    background: #627F8B;
    color: #fff;
    border-radius: 0;
  }
</style>


// WEBPACK FOOTER //
// src/components/ChartView.vue